import { forwardRef, memo } from 'react'
import { useDispatch } from 'react-redux'
import { MouseClickEvent } from 'builder/modules/ui'
import { FileInput } from 'builder/components/FillResumeModal/UploadResume/styles'
import { ALLOWED_FILES } from 'builder/components/FillResumeModal/constants'
import { ResumeValidationStatus } from 'builder/modules/constants'
import { actions } from 'builder/modules/resumeEditor'

const FileSelector = forwardRef<HTMLInputElement, unknown>((_props, ref) => {
  const dispatch = useDispatch()

  const handleClick = (event: MouseClickEvent) => {
    event.stopPropagation()
  }
  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedResume = event.target.files?.[0]

    if (!selectedResume) {
      return
    }

    dispatch(actions.setResumeValidationStatus(ResumeValidationStatus.uploading))
    dispatch(actions.setResumeForPrefill(selectedResume))
  }

  return (
    <FileInput
      type="file"
      ref={ref}
      onClick={handleClick}
      onChange={handleFileInputChange}
      accept={ALLOWED_FILES}
    />
  )
})

export default memo(FileSelector)
